module.exports = __webpack_public_path__ + "img/E8E5DE_B5AFA6_CCC5BC_C4C4BB-256px.01be2d70.png";